export enum JwtAlgorithm {
  Es384 = 'ES384'
}

export enum CredentialTypes {
  Token = 'Token',
  Client = 'Client',
  WebAuthn = 'WebAuthn'
}

export enum Permissions {
  GetUser = 'user.get',
  PatchUser = 'user.patch',
  GetTransaction = 'transaction.get',
  PostTransaction = 'transaction.post',
  PostGame = 'game.post',
  GetAccount = 'account.get',
  GetTransactionRequest = 'transaction-request.get',
  PostTransactionRequest = 'transaction-request.post',
  GetTransactionRequestResponse = 'transaction-request-response.get',
  PostTransactionRequestResponse = 'transaction-request-response.post',
  GetGame = 'game.get',
}

export const PermissionDescriptions = {
  [Permissions.GetUser]: 'Get a user.',
  [Permissions.PatchUser]: 'Update a user.',
  [Permissions.PostTransaction]: 'Create a transaction',
  [Permissions.GetTransaction]: 'Get a transaction',
  [Permissions.PostGame]: 'Create a game',
  [Permissions.GetGame]: 'Get a game',
  [Permissions.GetAccount]: 'Get user account',
  [Permissions.GetTransactionRequest]: 'Get a transaction request',
  [Permissions.PostTransactionRequest]: 'Create a transaction request',
  [Permissions.GetTransactionRequestResponse]: 'Get a transaction request response',
  [Permissions.PostTransactionRequestResponse]: 'Create a transaction request response',
};

export enum JwtType {
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  AuthnToken = 'authn_token'
}

export enum CryptoKeyUsage {
  Verify = 'verify',
  Sign = 'sign'
}

export enum CryptoHashingAlgorithms {
  SHA512 = 'SHA-512',
  SHA256 = 'SHA-256'
}

export enum CryptoKeyFormat {
  Spki = 'spki'
}

export enum CryptoKeyAlgorithm {
  Ecdsa = 'ECDSA'
}

export enum CryptoKeyNamedCurve {
  P384 = 'P-384'
}

export enum WebAuthnPublicKeyAlgorithms {
  Ed25519 = -8,
  ES256 = -7,
  RS256 = -257,
  RS512 = -259
}

export enum WebAuthnAttestation {
  Direct = 'direct',
  Indirect = 'indirect',
  None = 'none'
}

export enum WebAuthnAuthenticatorAttachment {
  Platform = 'platform',
  CrossPlatform = 'cross-platform'
}

export enum WebAuthnAuthenticatorUserVerification {
  Required = 'required',
  Preferred = 'preferred',
  Discouraged = 'discouraged'
}